import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-mini-compass',
  imports: [CommonModule],
  templateUrl: './mini-compass.component.html',
  styleUrl: './mini-compass.component.scss'
})
export class MiniCompassComponent {
  @Input() bearing = 293;
  @Input() size = 120;

  protected get needleRotation(): number {
    return this.bearing;
  }

  protected get radius(): number {
    return this.size / 2;
  }

  protected readonly compassPoints = [
    { label: 'N',  deg: 0,   isCardinal: true,  isNorth: true },
    { label: 'NE', deg: 45,  isCardinal: false, isNorth: false },
    { label: 'E',  deg: 90,  isCardinal: true,  isNorth: false },
    { label: 'SE', deg: 135, isCardinal: false, isNorth: false },
    { label: 'S',  deg: 180, isCardinal: true,  isNorth: false },
    { label: 'SW', deg: 225, isCardinal: false, isNorth: false },
    { label: 'W',  deg: 270, isCardinal: true,  isNorth: false },
    { label: 'NW', deg: 315, isCardinal: false, isNorth: false },
  ];

  protected readonly tickCount = 72;
}
